<template>
  <div class="captcha">
    <slot name="captcha-title"></slot>
    <div class="pl-4 pr-4">
      <!-- 我们通过电子邮件将验证码发送至输入验证完成注册{email}。-->
      <div class="captcha-text">{{$t('login.sendcodeemail',{email: email})}}</div>
      <div class="captcha-form">
        <el-input
            v-for="(item,i) in inputList"
            :key="i"
            :ref="`codeInput${i}`"
            v-model.trim="item.code"
            class="captcha-form-input"
            maxlength="1"
            minlength="1"
            onkeyup="this.value=this.value.replace(/\D/g,'')"
            oninput="this.value=this.value.replace(/\D/g,'')"
            @input="inputCode($event,i)"
            @paste.native="handlePaste($event)"
            @keydown.backspace.native="clickBackspace(item.code,i)"
            autocomplete="off"/>
      </div>
      <div class="captcha-btn">
        <!-- 继续-->
        <el-button class="mb-4" type="primary" :disabled="!isAllCodeFilled" @click="setPassword">{{$t('login.continue')}}</el-button>
        <!-- 重新发送-->
        <el-button class="ml-0" :disabled="sendCodeDisabled" @click="sendCodeAgain">{{$t('login.resend')}}<span v-if="sendCodeDisabled">（{{ count }}s）</span></el-button>
      </div>
      <!-- 老用户时显示 【接受不到验证码？密码登录】-->
      <div v-if="isOldUser" class="captcha-text captcha-tips tc">{{$t('login.noreceivecode')}}<span class="green-text-2 cursor-pointer" @click="passwordLogin">{{$t('login.passwordlogin')}}</span></div>
    </div>

  </div>
</template>

<script>
import {
  getLoginCode
} from "@/request/requests";
import {
  isEmpty,
  MessageError
} from "@/util/util";
const TIME_COUNT = 60;
export default {
  name: 'captcha',
  props:{
    email: String,
    isOldUser:{
      type:Boolean,
      default:()=>{
        return false
      }
    }
  },
  data(){
    return{
      inputList:[
        {
          code:''
        },
        {
          code:''
        },
        {
          code:''
        },
        {
          code:''
        }
      ],
      code:'',
      count:'',
      timer: null,
      sendCodeBtnText:'',
      sendCodeDisabled: true
    }
  },
  computed: {
    isAllCodeFilled(){
      return Array.from(this.inputList).every((obj) => obj.code);
    }
  },
  methods:{
    async toLogin() {
      let res = await getLoginCode(this.email)
      if (res.status == "200") {
        if(!isEmpty(res.data)){
          this.loginRes(res);
        }
      } else {
        MessageError(res.msg)
      }
    },
    loginRes(result) {
      let {
        userInfo,
        token,
        deadline
      } = result.data;
      // let {
      //   name: name
      // } = userInfo;
      this.$cookies.set("userInfo", JSON.stringify(userInfo), "7d");
      this.$cookies.set("token", token, "7d");
      this.$cookies.set("deadline", Date.parse(deadline), "7d");
      // this.$notification.success({
      //   message: "Login successful",
      //   description: `Welcome back，${name}`
      // });
      // if (localStorage.lang == 'kr') {
      //   this.$store.commit('setMenuListData', this.$store.state.map.menuListLogin)
      // } else if (localStorage.lang == 'it') {
      //   this.$store.commit('setMenuListData', this.$store.state.map.menuListLoginIt)
      // } else if (localStorage.lang == 'ar') {
      //   this.$store.commit('setMenuListData', this.$store.state.map.menuListLoginAr)
      // } else if (localStorage.lang == 'fr') {
      //   this.$store.commit('setMenuListData', this.$store.state.map.menuListLoginFr)
      // } else {
      //   this.$store.commit('setMenuListData', this.$store.state.map.menuListLoginEn)
      // }
      // this.$router.push({
      //   name: "home"
      // });
    },
    async sendCodeAgain(){
      let res = await getLoginCode(this.email)
      if (res.status == "200") {
        this.sendCode();
      } else {
        MessageError(res.msg)
      }
    },
    async sendCode() {
      this.sendCodeDisabled = true;
      this.timer = setInterval(() => {
        if (this.count > 0 && this.count <= TIME_COUNT) {
          this.count--;
        } else {
          clearInterval(this.timer);
          this.timer = null;
          this.sendCodeDisabled = false;
          this.count = TIME_COUNT;
        }
      }, 1000)
    },
    inputCode(code,i){
      this.$nextTick(() => {
        if (code.length == 1 && i < 3) {
          if (this.$refs['codeInput' + (i + 1)][0]) {
            this.$refs['codeInput' + (i + 1)][0].focus();
          }
        }
      });
    },
    handlePaste(event) {
      if (event.type === 'paste') {
        event.preventDefault();
        this.inputList = [{code:''},{code:''},{code:''},{code:''}];
        let pastedText = event.clipboardData.getData('text/plain');
        let pastedTextArr = Array.from(pastedText);
        if(pastedTextArr.length===4){
          pastedTextArr.forEach((pItem,pIndex)=>{
            this.inputList.forEach((codeItem,codeIndex)=>{
              if(pIndex===codeIndex){
                this.$set(codeItem,'code',pItem);
              }
            })
          })
          this.$refs['codeInput'+(this.inputList.length - 1)][0].focus();
        }
      }
    },
    clickBackspace(code,i){
      this.$nextTick(()=>{
        if(code.length==0 && i > 0){
          if(this.$refs['codeInput'+(i - 1)][0]){
            this.$refs['codeInput'+(i - 1)][0].focus();
          }
          this.$set(this.inputList[i],'code','');
        }
      })
    },
    passwordLogin(){
      this.$emit('passwordLogin');
    },
    setPassword(){
      this.code = '';
      this.inputList.forEach(item=>{
        this.code += item.code
      })
      this.$emit('setPassword',this.code);
    }
  },
  mounted(){
    this.$refs['codeInput0'][0].focus();
    this.count = TIME_COUNT;
    // this.sendCodeAgain();
    this.sendCode();
  }
};
</script>

<style lang="scss" scoped>
@import "../../../assets/css/login.scss";
</style>